import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const AddressFields = ({ value, onChange, inputClass }) => {
  const { t } = useTranslation();
  
  // Memoize the normalized value to prevent flickering
  const normalizedValue = useMemo(() => {
    return {
      street: value?.street || '',
      number: value?.number || '',
      floor: value?.floor || '',
      apartment: value?.apartment || ''
    };
  }, [value?.street, value?.number, value?.floor, value?.apartment]);
  
  return (
    <div className="min-h-[57px] space-y-1">
      <div>
        <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
          {t('jobs.streetAddress')}
        </label>
        <input
          type="text"
          value={normalizedValue.street}
          onChange={(e) => onChange({ street: e.target.value })}
          className={inputClass}
          autoCapitalize="words"
          autoCorrect="off"
          spellCheck={false}
          placeholder={t('jobs.enterStreetName')}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
            {t('jobs.number')}
          </label>
          <input
            type="text"
            value={normalizedValue.number}
            onChange={(e) => onChange({ number: e.target.value })}
            className={inputClass}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            placeholder={t('jobs.no')}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
            {t('jobs.floor')}
          </label>
          <input
            type="text"
            value={normalizedValue.floor}
            onChange={(e) => onChange({ floor: e.target.value })}
            className={inputClass}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            placeholder={t('jobs.floor')}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-200 mb-1 mt-1">
            {t('jobs.apartment')}
          </label>
          <input
            type="text"
            value={normalizedValue.apartment}
            onChange={(e) => onChange({ apartment: e.target.value })}
            className={inputClass}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            placeholder={t('jobs.apt')}
          />
        </div>
      </div>
    </div>
  );
};

export default AddressFields;


